import { Instance } from 'mobx-state-tree';
import { ProjectVisitGeocodedDtoModelBase } from './ProjectVisitGeocodedDtoModel.base';

/* The TypeScript type of an instance of ProjectVisitGeocodedDtoModel */
export interface ProjectVisitGeocodedDtoModelType extends Instance<typeof ProjectVisitGeocodedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectVisitGeocodedDtoModel */
export { selectFromProjectVisitGeocodedDto, projectVisitGeocodedDtoModelPrimitives, ProjectVisitGeocodedDtoModelSelector } from './ProjectVisitGeocodedDtoModel.base';

/**
 * ProjectVisitGeocodedDtoModel
 *
 * Visit geocoded event for project level
 */
export const ProjectVisitGeocodedDtoModel = ProjectVisitGeocodedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
